<template>
  <div>
    <Card shadow>
      <Row :gutter="18">
        <Col span="1">
          <Button type="primary" @click="userRiskBuffList">刷新</Button>
        </Col>
        <Button
          style="float: right; margin-right: 5px"
          type="primary"
          @click="addModal"
          >添加配置</Button
        >
      </Row>
    </Card>
    <Table
      style="margin-top: 10px"
      border
      :columns="table.columns"
      :data="table.data"
    ></Table>

    <Modal v-model="setUser_modal.show" width="500" @on-cancel="CloseModal">
      <div slot="header">
        {{ this.setUser_modal.params.id ? '修改' : '添加' }}个人标签
      </div>
      <Form
        :ref="setUser_modal.ref"
        :model="setUser_modal.params"
        :rules="setUser_modal.rules"
        :label-width="120"
      >
        <Row>
          <Col span="20">
            <FormItem label="标签名称" prop="name">
              <Input
                :disabled="setUser_modal.params.type > 0"
                v-model="setUser_modal.params.name"
                placeholder="标签名称"
                clearable
              />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="标签值" prop="user_tag">
              <InputNumber
                v-model="setUser_modal.params.user_tag"
                placeholder="标签值"
                style="width: 100%"
                :min="0"
              ></InputNumber>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="CloseModal">关闭</Button>
        <Button type="warning" @click="updateUserRiskBuff">提交</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { GetUserTagList, SetUserTag } from '@/api/admin/player'
export default {
  name: 'labelManagement',
  data() {
    return {
      select: {
        pvp_level_LIst: [
          { value: 2, name: '黑2' },
          { value: 1, name: '黑1' },
          { value: 0, name: '正常' },
          { value: -1, name: '白1' },
          { value: -2, name: '白2' }
        ]
      },
      //表单数据
      table: {
        data: [],
        columns: [
          { type: 'index', title: '序号', width: 100, align: 'center' },
          { key: 'id', align: 'center', title: 'ID' },
          { key: 'user_tag', align: 'center', title: '标签值' },
          { key: 'name', align: 'center', title: '标签名称' },
          {
            title: '管理',
            key: 'action',
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h(
                  'Button',
                  {
                    props: { type: 'primary' },
                    style: { margin: '2px', padding: '3px 8px' },
                    on: {
                      click: () => {
                        this.ModalShow()
                        this.setUser_modal.params = { ...params.row, type: 1 }
                      }
                    }
                  },
                  '修改'
                ),
                h(
                  'Button',
                  {
                    props: { type: 'error' },
                    style: { margin: '2px', padding: '3px 8px' },
                    on: {
                      click: () => this.removemsg(params.row.id)
                    }
                  },
                  '删除'
                )
              ])
            }
          }
        ],
        total: 0,
        pageSizes: [10, 20, 30, 40]
      },

      //玩家buff配置
      setUser_modal: {
        show: false,
        ref: 'setUser',
        params: { id: '', user_tag: 0, name: '', type: 0 },
        rules: {
          name: [
            {
              required: true,
              trigger: 'blur',
              validator: this.simpleVerify('请输入个人标签名称')
            }
          ],
          user_tag: [
            {
              required: true,
              trigger: 'blur',
              validator: (rule, value, callback) => {
                if (value == null || value < 0) {
                  callback('个人标签不能小于0')
                } else {
                  callback()
                }
              }
            }
          ]
        }
      }
    }
  },
  methods: {
    //获取列表
    userRiskBuffList() {
      GetUserTagList({}).then(res => {
        this.table.data = res._param.list || []
      })
    },
    //修改新增风控buff
    updateUserRiskBuff() {
      this.$refs[this.setUser_modal.ref].validate(valid => {
        if (valid) {
          let param = { ...this.setUser_modal.params }
          SetUserTag(param).then(res => {
            this.userRiskBuffList()
            this.CloseModal()
          })
        }
      })
    },
    addModal() {
      this.setUser_modal.params = { id: '', user_tag: 0, name: '', type: 0 }
      this.ModalShow()
    },
    ModalShow() {
      this.$refs[this.setUser_modal.ref].resetFields()
      this.setUser_modal.show = true
    },
    CloseModal() {
      this.$refs[this.setUser_modal.ref].resetFields()
      this.setUser_modal.show = false
    },

    // 删除个人风控
    removemsg(id) {
      this.$Modal.confirm({
        title: '确认删除',
        content: '<p>是否确认将这条玩家个人标签配置删除。</p>',
        onOk: () => {
          let params = { id: id, type: 2 }
          SetUserTag(params).then(res => {
            this.userRiskBuffList()
          })
        },
        onCancel: () => {}
      })
    }
  },

  created() {
    this.userRiskBuffList()
  }
}
</script>
<style lang="less" scoped>
.btn_batch {
  margin-right: 12px;
}
</style>
